import React from 'react';
import Container from '@/container';
import {Row, Col} from '@/grid';
import {withBgLearnMore} from '@/hocs/withColors';
import {H3} from '@/typography';
import Link from '@/links';
import {withMarginBottomZeroToMd} from '@/hocs/withSpacing';
import {withFlexHolder} from '@/hocs/withFlex';
import {withTextLeftToCenter, withFloatRightToCenter} from '@/hocs/withAlignment';
import styles from './styles.module.scss';

const LearnMoreDiv = withBgLearnMore('div');
const FlexCenter = withFlexHolder(LearnMoreDiv);
const LefttoCenterH3 = withMarginBottomZeroToMd(withTextLeftToCenter(H3));
const FloatRight = withFloatRightToCenter('div');

const LearnMore = () => (
  <FlexCenter>
    <Container>
      <div className={styles.banner}>
        <Row center="xs" middle="lg">
          <Col xs={12} lg={7}>
            <LefttoCenterH3>
              Want to learn more about how Workable helps you manage and demonstrate compliance?
            </LefttoCenterH3>
          </Col>
          <Col xs={12} lg={3}>
            <FloatRight>
              <Link
                href="/demo"
                variant="primary"
                customAttributes={{
                  'data-gtm': 'security-demo',
                  'data-ui': 'security-demo'
                }}>
                Request a demo
              </Link>
            </FloatRight>
          </Col>
        </Row>
      </div>
    </Container>
  </FlexCenter>
);

export default LearnMore;
